export const ADS_ACCOUNT_MODAL_MSG =
    "Please check your email and verify this account. We will connect you to the account once that is properly verified";
export const ADS_ACCOUNT_PENDING_MODAL_MSG = `We have checked that your new Google Ads account is not properly verified yet. ${ADS_ACCOUNT_MODAL_MSG}`;
export const ADS_ACCOUNT_VERIFIED_MODAL_MSG =
    "Thank you for verifying the ads account. We are now connection you to tht ads account";
